const STORAGE_KEY = 'ninet6_agentRef';

export function normalizeAgentRef(value) {
  return String(value || '').trim().toUpperCase();
}

export function captureAgentRefFromSearch(search) {
  try {
    const params = new URLSearchParams(String(search || ''));
    const code = normalizeAgentRef(params.get('agentRef'));
    if (code && typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem(STORAGE_KEY, code);
    }
    return code;
  } catch {
    return '';
  }
}

export function captureAgentRefFromLocation() {
  if (typeof window === 'undefined') return '';
  return captureAgentRefFromSearch(window.location.search);
}

export function readStoredAgentRef() {
  try {
    return normalizeAgentRef(typeof sessionStorage !== 'undefined' ? sessionStorage.getItem(STORAGE_KEY) : '');
  } catch {
    return '';
  }
}

export function agentRefStorageKey() {
  return STORAGE_KEY;
}
